const getters = {
  getCommissionRequest: (state) => state.commissionRequest,
  getCommissionRequestList: (state) => state.commissionRequestList,
  getCommissionRequestListMeta: (state) => state.commissionRequestMeta,
};

export default getters;
